var c = "/static/bc82357e1af8b2df.png";

export { c as default };
//# sourceMappingURL=deposit.png.js.map
